import React from 'react'
import {Btn1} from '../../Module_Exporter/Module_Exporter';

function ServiceCard(props) {

   
   


  return (
<article data-aos={props.aos} className="service_cards">
      <i className={props.icon}></i>
      <h3 className='heading'>{props.title}</h3>
      <div className="services_details">
        <p>{props.service_details}</p>
        <Btn1 url={props.url}  cl="services_details_btn" value="Explore More"/>
    
      </div>
     </article>

  )
}
ServiceCard.defaultProps={
 url:"/#",
 service_details:"Lorem ipsum dolor sit amet.Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perferendis, unde. 123123",
 title:"Enter Title",
 icon:"fas fa-laptop-code",
 aos:"flip-up"
}

export default ServiceCard;